import React, {Component} from 'react';
import {connect} from 'react-redux';
import Divider from '../../gadgets/Divider';
import {Link} from 'react-router-dom';
import Image from '../../components/Image'
import SwipePhoto from '../../gadgets/SwipePhoto';
import dataAPI from '../../_Utilities/DataAPI';
import {Helmet} from 'react-helmet';
import '../styles/ProjectPage.css';

window.scrollTo(0, 0);

class ProjectPage extends Component {
    render() {
        // Get data from the object store
        const project = dataAPI.findOneByKey(this.props.projects)('key', this.props.match.params.key);
        const graduates = dataAPI.findAllByKey(this.props.graduates)('unikey', project.graduates);

        const gallery = project.images.gallery ? (
            <SwipePhoto images={project.images.gallery}>
            </SwipePhoto>
        ) : null;

        const video = project.video ? (
            <div className={'col--12 colour-strip colour-strip--pink'}>
                <div className={'col--12 col--no-padding'}>
                    <div className={'video-container'}>
                        <iframe title={'Promo Video'} width="100%" height="100%" src={project.video}
                                frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen>
                        </iframe>
                    </div>
                </div>
            </div>
        ) : null;

        const image = project.images.gallery[0] ? (
            <div className={'col--12 colour-strip colour-strip--pink'}>
                <Image src={project.images.gallery[0].full} cover={true} aspectRatio={'4:2'} shadow/>
            </div>
        ) : null;
        return (
            <div className={'container'}>
                <Helmet>
                    <title>{project.title} • Projects • D18</title>
                </Helmet>
                <div className={'section section--pink header'}>
                </div>
                <section>
                    <div className={'grid'}>
                        <div className={'col--12'}>
                            <h1>{project.title}</h1>
                            <Divider color={'pink'} type={'short'}/>
                        </div>
                        <div className={'col--4'}>
                            <div className={'fineprint fineprint--bold'}>
                                TEAM MEMBERS
                            </div>
                            <div className={'fineprint fineprint--grey'}>
                                {graduates.map((graduate, i) => {
                                    return (
                                        <Link key={i} to={
                                            {
                                                pathname: `/projects/${project.key}/${graduate.unikey}`,
                                                state: {modal: true, path: `/projects/${project.key}`}
                                            }
                                        }>
                                            <span>{i === 0 ? '' : ', '}{graduate.fullName}</span>
                                        </Link>
                                    )
                                })}
                            </div>
                        </div>
                        {video ? video : image}
                        <div className={'col--12'}>
                            <h3 className={'text--bold title-text'}>About the project</h3>
                            {project.description}
                        </div>
                        {gallery}
                    </div>
                </section>
            </div>
        )
    }
}

const MapStateToProps = (state) => ({
    projects: state.projects,
    graduates: state.graduates
});

export default connect(MapStateToProps)(ProjectPage);